import { Link } from 'react-router-dom'
import DefaultButton from '../../Button/Button'

const Questions = () => {
  return (
    <div className="w-full max-w-md md:w-[57.56rem] mx-auto flex flex-col items-center gap-3 md:gap-3 mt-12 lg:mt-20">
      <h1 className="text-[22px] md:text-[40px] font-normal">Still Have Questions</h1>
      <p className="text-[#ADB5BD] font-medium text-[13px] md:text-lg md:mb-3">
        Can’t find the answer you are looking for?
      </p>
      <Link to="/contact-us">
        <DefaultButton>Contact Us</DefaultButton>
      </Link>
    </div>
  )
}

export default Questions
